import { z } from 'zod';
import { UserSchema } from './web.js';
export const LoginIdSchema = z
  .string()
  .regex(/^[a-z0-9_-]{3,32}$/, 'ログイン ID は英小文字・数字・_・- の 3〜32 文字にしてください');
export const LoginIdentitySchema = z.object({ login: LoginIdSchema }).passthrough();
export const PasswordSchema = z
  .string()
  .min(12, 'パスワードは 12 文字以上にしてください')
  .max(128, 'パスワードは 128 文字以内にしてください');
export const CodeSchema = z.string().regex(/^(?:[0-9]{6}|[A-Z2-7]{10})$/);
export const LoginInputSchema = z.object({ login: LoginIdSchema, password: PasswordSchema }).strict();
export const LoginVerifySchema = z.object({ code: CodeSchema }).strict();
export const LoginChallengeSchema = z.object({ expiresAt: z.string().datetime() });
export type LoginChallenge = z.infer<typeof LoginChallengeSchema>;
export const EnrollmentInputSchema = z
  .object({ name: z.string().trim().min(1).max(100), login: LoginIdSchema, password: PasswordSchema })
  .strict()
  .refine((v) => !v.password.toLowerCase().includes(v.login), {
    message: 'パスワードにログイン ID は含められません',
    path: ['password'],
  });
export const EnrollmentVerifySchema = z.object({ code: z.string().regex(/^[0-9]{6}$/) }).strict();
export const StepUpInputSchema = z.object({ code: CodeSchema }).strict();
export const CurrentCredentialsSchema = z.object({ password: PasswordSchema, code: CodeSchema }).strict();
export const PasswordChangeSchema = CurrentCredentialsSchema.extend({ newPassword: PasswordSchema });
export const EnrollmentOptionsSchema = z.object({ secret: z.string(), uri: z.string(), login: LoginIdSchema });
export type EnrollmentInput = z.infer<typeof EnrollmentInputSchema>;
export type EnrollmentOptions = z.infer<typeof EnrollmentOptionsSchema>;
export const SetupEnrollmentSchema = EnrollmentInputSchema.safeExtend({ token: z.string().min(1) });
export const SetupVerifySchema = EnrollmentVerifySchema.extend({ token: z.string().min(1) });

export const LoginResultSchema = z.object({ user: UserSchema });
export const EnrollmentResultSchema = LoginResultSchema.extend({
  recoveryCodes: z.array(z.string().regex(/^[A-Z2-7]{10}$/)).length(10),
});
export const StepUpResultSchema = z.object({ steppedUpUntil: z.string() });
export const ResetInfoSchema = z.object({ login: LoginIdSchema.optional(), name: z.string() });
export const ResetLinkSchema = z.object({ url: z.string() });
export type EnrollmentResult = z.infer<typeof EnrollmentResultSchema>;
export type StepUpResult = z.infer<typeof StepUpResultSchema>;

export const RecoveryRegenerateSchema = CurrentCredentialsSchema.extend({ code: z.string().regex(/^[0-9]{6}$/) });
export const RecoveryStatusSchema = z.object({ remaining: z.number().int().min(0).max(10) });
export const RecoveryCodesResultSchema = EnrollmentResultSchema.pick({ recoveryCodes: true });
export type RecoveryStatus = z.infer<typeof RecoveryStatusSchema>;
export type RecoveryCodesResult = z.infer<typeof RecoveryCodesResultSchema>;
